import React, { FC, useState } from 'react'
import { SelectProps as AntSelectProps } from 'antd/lib/select'
import { Button, Input } from '../../atoms'
import clsx from 'clsx'
import { Icon } from '@iconify/react'

import styles from './_.module.css'

interface Props extends AntSelectProps<string> {
  addItem: (value: { width: string; height: string }) => void
  setValue: (value: any) => void
  disable?: boolean
}

export const DimensionsSelectV2: FC<Props> = ({
  setValue,
  options,
  value,
  addItem,
  disabled
}) => {
  const [showCustomAdd, toggleShowCustomAdd] = useState(false)
  const [dimensions, setDimensions] = useState({ width: '', height: '' })
  if (options) {
    const visualOptions: any = [...options]
    if (value && !options?.find(optionItem => optionItem.value === value)) {
      visualOptions?.push({
        image: 'https://assets.peppercontent.io/icons/misc/squareLayout.svg',
        label: value,
        subLabel: '',
        value
      })
    }

    return (
      <div>
        <div className={styles.dimensionWrap}>
          {visualOptions?.map((option: any, index: number) => {
            return (
              <div
                role="none"
                className={clsx(styles.dimensionItem, {
                  [styles.activeDimensionItem]: value === option.value,
                  [styles.optionDisabled]: disabled
                })}
                onClick={() => !disabled && setValue(option.value)}
                key={index}
              >
                <img
                  src={
                    option.image ||
                    'https://assets.peppercontent.io/icons/misc/squareLayout.svg'
                  }
                  alt="dimension"
                  className={styles.dimensionImage}
                />
                <div className={styles.header}>{option.label}</div>
                <div className={styles.subHeader}>{option.subLabel}</div>
              </div>
            )
          })}
        </div>
        {!showCustomAdd && (
          <div>
            <div
              role="none"
              onClick={() => !disabled && toggleShowCustomAdd(true)}
              className={clsx(styles.customLayoutWrap, {
                [styles.optionDisabled]: disabled
              })}
            >
              <Icon
                icon="ant-design:plus-outlined"
                className={styles.plusCustom}
              />
              <span className={styles.customLayoutText}>Add custom layout</span>
            </div>
          </div>
        )}

        {showCustomAdd && (
          <div className={styles.addOptions}>
            <Input
              className={clsx(styles.inputOp, {
                [styles.optionDisabled]: disabled
              })}
              value={dimensions.width}
              placeholder="Width"
              size="middle"
              type="number"
              disabled={disabled}
              onChange={e => {
                if (Number(e.target.value) >= 0) {
                  setDimensions({
                    width: e.target.value,
                    height: dimensions.height
                  })
                }
              }}
            />
            <div className={styles.operator}>X</div>
            <Input
              className={clsx(styles.inputOp, {
                [styles.optionDisabled]: disabled
              })}
              value={dimensions.height}
              placeholder="Height"
              size="middle"
              type="number"
              disabled={disabled}
              onChange={e => {
                if (Number(e.target.value) >= 0) {
                  setDimensions({
                    width: dimensions.width,
                    height: e.target.value
                  })
                }
              }}
            />
            <div className={styles.operator}>px</div>
            <Button
              className={clsx(styles.addBtn, {
                [styles.optionDisabled]: disabled
              })}
              icon={<Icon icon="ant-design:plus-outlined" />}
              disabled={!dimensions.width || !dimensions.height || disabled}
              type="link"
              onClick={() => {
                addItem(dimensions)
                setDimensions({ width: '', height: '' })
                toggleShowCustomAdd(false)
              }}
            >
              Add Custom
            </Button>
          </div>
        )}
      </div>
    )
  }
  return null
}
